import { MqttSourcesTable } from "@/components/mqtt/mqtt-sources-table";

export function SourcesPage() {
	return (
		<div className="flex flex-1 flex-col gap-4 p-4 lg:p-6">
			<MqttSourcesTable />
		</div>
	);
}
